import { Component } from '@angular/core';

import { navItems } from './_nav';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from '../../ok-alone.service';
import { translate, TranslocoService } from '@ngneat/transloco';

import { INavData } from '@coreui/angular-pro';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.scss']
})
export class DefaultLayoutComponent {

  public navItems: INavData[] = [];

  public perfectScrollbarConfig = {
    suppressScrollX: true,
  };

  loading = false;

  constructor(private router: Router, public okService:OkAloneService,private transloco: TranslocoService) {


    this.okService.menuUpdateChange.subscribe(value => {

      //console.log("menu Changed");
      this.navItems = this.okService.buildMenu();

    });

   }

  

   ngOnInit(): void {
 
     this.transloco.selectTranslate('Hello').subscribe(value => {
 
       this.navItems = this.okService.buildMenu();
 
     });
     this.toggleSubMenus();
 
   }

   toggleSubMenus(){
   
     let self = this;
   
   }

   sideMenu(id:string,open:boolean){
   
     if(open){
       (document.getElementsByClassName("side-menu-"+id)[0]).classList.add("show");
       localStorage.setItem("side-menu-"+id,'open')
     }else{
       (document.getElementsByClassName("side-menu-"+id)[0]).classList.remove("show");
       localStorage.setItem("side-menu-"+id,'close')
     }
   }
   
     extend(){
   
       this.loading = true;
   
           this.okService.post("billing/extend",{})
           .subscribe((data) => {
   
             this.loading = false;
   
             let response:any = data.body;
   
   
             if(response.success){
   
               //console.log("Update the billing");
   
               this.okService.get("billing",{})
               .subscribe((data:any) => {
   
                 
                 this.okService.billing = data.body;
   
                 //console.log(this.okService.billing);
   
                 this.okService.setAlert(response.message,"success");
   
               })
   
             }
             
           })
         }


}
